import fastdom from 'fastdom';

class OverflowScroller {
  constructor(element) {
    this.element = element;
    this.lastKnownY = window.scrollY;
    this.currentTop = 0;

    this.attachListeners();
  }

  attachListeners() {
    if (!this.element) return;
    this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);
    window.addEventListener('scroll', this.setPosition.bind(this));
  }

  destroy() {
    this.element.removeEventListener('scroll', this.setPosition.bind(this));
  }

  setPosition() {
    fastdom.measure(() => {
      const { top } = this.element.getBoundingClientRect();
      const maxTop = top + window.scrollY - this.element.offsetTop + this.initialTopOffset;
      const minTop = this.element.clientHeight - window.innerHeight;

      if (window.scrollY < this.lastKnownY) {
        this.currentTop -= window.scrollY - this.lastKnownY;
      } else {
        this.currentTop += this.lastKnownY - window.scrollY;
      }

      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTopOffset);
      this.lastKnownY = window.scrollY;
    });

    fastdom.mutate(() => this.element.style.top = `${this.currentTop}px`);
  }
}

export default OverflowScroller;
